import React, { useState } from "react";
import Modal from "react-modal";
import heroVideo from "../../assets/logoanimation.mp4";
import heroImgMobile from "../../assets/bg-explosion1.png";
import heroBackground from "../../assets/bg-explosion1.png"; // Your new background image
import cancelImg from "../../assets/img/cancel.svg";
import Index from "../../components/about/index";

// Social media icons
import { FaInstagram, FaLinkedin, FaFacebook, FaBehance } from "react-icons/fa";

const heroContent = {
  heroVideo: heroVideo,
  heroMobileImage: heroImgMobile,
  heroTitleName: "Victory Cineworld",
  heroDesignation: "Elevating Brands, Frame by Frame",
  heroDescriptions: `Victory Cineworld delivers stunning visuals and compelling narratives. We specialize in crafting high-quality videos and designs that captivate your audience and drive results. From corporate videos to social media campaigns, we've got you covered. Let's create something extraordinary together.`,
  heroBtn: "more about us",
};

const Hero = () => {
  const [isOpen, setIsOpen] = useState(false);

  function toggleModalOne() {
    setIsOpen(!isOpen);
  }

  return (
    <>
      <div
        className="row home-details-container align-items-center"
        style={{
          backgroundImage: `url(${heroBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "100vh",
          position: "relative",
        }}
      >
        {/* Video Section */}
        <div
          className="col-lg-6 d-flex justify-content-center align-items-center"
          style={{
            position: "relative",
          }}
        >
          {/* Video */}
          <video
            src={heroVideo}
            autoPlay
            loop
            muted
            playsInline
            style={{
              width: "55%",
              height: "22%",
              objectFit: "cover",
              borderRadius: "20px",
              boxShadow: "10px 8px 20px rgba(0, 0, 0, 1)",
            }}
          />
        </div>

        {/* Text Section */}
        <div
          className="col-lg-6 d-flex flex-column align-items-start"
          style={{ padding: "0 " }}
        >
          {/* Main Heading */}
          <h2
            style={{
              fontSize: "2.8rem",
              fontWeight: "800",
              color: "orange",
              margin: 0,
              textShadow: "2px 2px 4px black",
            }}
          >
            {heroContent.heroTitleName}
          </h2>

          {/* Subheading */}
          <h2
            style={{
              fontSize: "1.5rem",
              fontWeight: "650",
              color: "white",
              margin: 0,
              textShadow: "2px 2px 4px black",
            }}
          >
            {heroContent.heroDesignation}
          </h2>

          {/* Description */}
          <p
            style={{
              color: "white",
              fontWeight: "200",
              maxWidth: "520px",
              textAlign: "justify",
              margin: "20px 0",
              fontSize: "20px",
              textShadow: "2px 2px 4px black",
            }}
          >
            {heroContent.heroDescriptions}
          </p>

          {/* Button and Social Media Icons */}
         
          <div className="d-flex align-items-center gap-3 " style={{marginLeft:115}} >
            

            <div className="social-icons d-flex ">
              <a
                href="https://www.instagram.com/victory_cineworld/"
                target="_blank"
                rel="noopener noreferrer"
                className="me-3"
              >
                <FaInstagram size={28} color="white" />
              </a>
              <a
                href="https://www.linkedin.com/company/victorycineworld/"
                target="_blank"
                rel="noopener noreferrer"
                className="me-3"
              >
                <FaLinkedin size={28} color="white" />
              </a>
              <a
                href=""
                target="_blank"
                rel="noopener noreferrer"
                className="me-3"
              >
                <FaBehance size={28} color="white" />
              </a>
              <a href="" target="_blank" rel="noopener noreferrer">
                <FaFacebook size={28} color="white" />
              </a>
            </div>

            <div >
            <button className="button order  " onClick={toggleModalOne}>
              <span className="button-text">{heroContent.heroBtn}</span>
              <span className="button-icon fa fa-arrow-right"></span>
            </button>
            </div>
          </div>
          
        </div>
      </div>

      {/* Modal */}
      <Modal
        isOpen={isOpen}
        onRequestClose={toggleModalOne}
        contentLabel="My dialog"
        className="custom-modal dark hero"
        overlayClassName="custom-overlay dark"
        closeTimeoutMS={500}
      >
        <div>
          <button className="close-modal" onClick={toggleModalOne}>
            <img src={cancelImg} alt="close icon" />
          </button>

          <div className="box_inner about">
            <div data-aos="fade-up" data-aos-duration="1200">
              <Index />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Hero;
